// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * The IDL section, and so the wire message kind, a key arrives as.
 */
export enum Category {
  Parameter = 0,
  Monitor = 1,
  Status = 2,
  Command = 3,
}
